var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldcontroller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m483.13 245.38c-21.21-95.89-53.13-147.07-100.48-161.05a107.13 107.13 0 0 0 -30.65-4.33c-13.71 0-25.65 3.34-38.28 6.88-15.22 4.27-32.51 9.12-57.72 9.12s-42.51-4.84-57.76-9.11c-12.64-3.55-24.57-6.89-38.24-6.89a115.74 115.74 0 0 0 -31.73 4.32c-47.1 13.92-79 65.08-100.52 161-23.14 103.22-11.75 168.39 31.94 183.51a56.62 56.62 0 0 0 18.64 3.22c29.93 0 53.93-24.93 70.33-45.34 18.53-23.1 40.22-34.82 107.34-34.82 59.95 0 84.76 8.13 106.19 34.82 13.47 16.78 26.2 28.52 38.9 35.91 16.89 9.82 33.77 12 50.16 6.37 25.82-8.81 40.62-32.1 44-69.24 2.57-28.48-1.39-65.89-12.12-114.37zm-275.13-5.38h-32v32a16 16 0 0 1 -32 0v-32h-32a16 16 0 0 1 0-32h32v-32a16 16 0 0 1 32 0v32h32a16 16 0 0 1 0 32zm84 4a20 20 0 1 1 20-20 20 20 0 0 1 -20 20zm44 44a20 20 0 1 1 20-19.95 20 20 0 0 1 -20 19.95zm0-88a20 20 0 1 1 20-20 20 20 0 0 1 -20 20zm44 44a20 20 0 1 1 20-20 20 20 0 0 1 -20 20z",
    fill: "#ffd700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldcontroller);
export default __webpack_public_path__ + "static/media/goldcontroller.04aa2bcf33dc86692ea7890f0203da62.svg";
export { ForwardRef as ReactComponent };